const Modal = require('../ui/modal');
const SafeDrawCurve = require('./visuals/safe-draw-curve').default;
const template = require('./tactic-details.tpl').default;

module.exports = DomClass(template, function() {
	var _t = this;

	Modal.call(this);

	on(this, 'close').then(function() {
		document.body.removeChild(_t);
	});

	this.safeDrawGraph = new SafeDrawCurve({data: this.safeDrawData});

	this.__dom.closeLink.onclick = function() {
		_t.close();
	};

	document.body.appendChild(this);

});
